export default __webpack_public_path__ + "static/media/plus.0fa03f16.PNG";